import { Component, Inject, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../button/button.component';
import { AuthService } from '@core/services/auth.service';
import { TranslationDirective } from '../../translata-modal/translation.directive';
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-default-dialog-box',
  templateUrl: './default-dialog-box.component.html',
  styleUrls: ['./default-dialog-box.component.scss'],
  imports: [TranslationDirective, TranslateModule, ButtonComponent],
})
export class DefaultDialogBoxComponent {
  readonly dialogRef = inject(DialogRef);
  imagelang: string;
  headerText: string;
  subText: string;
  confirm: string;
  decline: string;
  constructor(
    @Inject(DIALOG_DATA) public data: any,
    private auth: AuthService
  ) {
    this.imagelang = this.auth.user.lang;
    this.headerText = this.data.headerText;
    this.subText = this.data.subText;
    this.confirm = this.data.confirm || 'ja';
    this.decline = this.data.decline || 'nein';
  }
}
